<div class="callback-container">
    <mat-spinner></mat-spinner>
    <p>Autenticando...</p>
  </div>
  